/**
 * P-56 (D-231 §1) — the one-create-at-a-time guard of the task form, and the id
 * of one create attempt (the `Idempotency-Key` of POST /tickets).
 *
 * `enter()` is true for the first caller only; every other (a second click, Enter
 * in a field while the "לשייך גם?" question or the upload is open) gets false until
 * `leave()`. The attempt key stays the same while the outcome is unknown (no answer
 * from the server) and changes after a real answer (an error that the user fixes).
 */
export function createSubmitGuard(makeKey: () => string) {
  let busy = false;
  let key = makeKey();
  return {
    enter(): boolean {
      if (busy) return false;
      busy = true;
      return true;
    },
    leave(): void { busy = false; },
    get key(): string { return key; },
    /** The server answered with a failure: the next attempt is a new one. */
    renewKey(): void { key = makeKey(); },
    get busy(): boolean { return busy; },
  };
}

/** One id per create attempt. */
export function newAttemptKey(): string {
  return typeof crypto !== 'undefined' && 'randomUUID' in crypto
    ? crypto.randomUUID()
    : `k-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
